// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"5c9053ab","395":"d1ab050c"}[chunkId] + ".chunk.css";
};